namespace Reviews {

    class ReviewSubmitted {

        public hotelDetails: HotelInformation;
        public reviews :any;
        public reviewSiteDetails :any;

        constructor(protected $q: ng.IQService,
                    protected $routeParams: ng.route.IRouteParamsService,
                    protected reviewService: any,
                    protected reviewsService: ReviewsService) {

            //there should be a hotel id as part of the route params
            let hotelId = $routeParams.hotelId;

            $q.all([
                this.reviewsService.getHotelInformation(hotelId),
                this.reviewService.getReviews({ Id: hotelId }, 0)
            ]).then(results => {
                this.hotelDetails = results[0];
                this.reviews = results[1].reviews;
            });
        }
    }

    angular
        .module('reviews')
        .controller('ReviewSubmitted', ReviewSubmitted);

}
